export const convertMinutesToHours = (
  minutesTotal: number = 0,
  separator?: string,
) => {
  const hours = Math.floor(minutesTotal / 60);
  const minutes = Math.ceil((minutesTotal / 60 - hours) * 60);

  return `${hours < 10 ? '0' + hours : hours}${separator ? separator : 'h'}${
    minutes < 10 ? '0' + minutes : minutes
  }`;
};
